import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import API, { CATEGORY_LABELS } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";
import { useContent } from "@/context/ContentProvider";

const Catalog = () => {
  const { t } = useContent();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "todos";

  useEffect(() => {
    setLoading(true);
    const qs = category !== "todos" ? `?category=${category}` : "";
    API.get(`/products${qs}`)
      .then((r) => setProducts(r.data.products))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [category]);

  return (
    <div className="min-h-screen bg-[#faf7f2] pb-24 pt-[120px]" data-testid="catalog-page">
      <div className="grain bg-[#4b3a2f] py-16 text-center">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <p className="font-mono-d text-[11px] uppercase tracking-[0.28em] text-[#c9a24b]">Tienda AWEN</p>
          <h1 className="mt-4 font-serif-d text-5xl font-semibold text-[#f2e9dd] sm:text-6xl">
            Catálogo de <em className="text-[#c9a24b]">bienestar</em>
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-[#cdb79e]">
            Cursos, talleres y terapias diseñadas por especialistas para acompañarte en cada etapa.
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="hide-scrollbar mt-10 flex gap-2 overflow-x-auto pb-2">
          {[{ id: "todos", label: "Todos" }, ...Object.entries(CATEGORY_LABELS).map(([id, label]) => ({ id, label }))].map(
            (c) => (
              <button
                key={c.id}
                onClick={() => setParams(c.id === "todos" ? {} : { category: c.id })}
                data-testid={`category-filter-${c.id}`}
                className={`whitespace-nowrap rounded-full border px-5 py-2.5 text-sm transition-all duration-300 ${
                  category === c.id
                    ? "border-[#4b3a2f] bg-[#4b3a2f] text-[#f2e9dd]"
                    : "border-[#4b3a2f]/20 bg-white text-[#6b5b52] hover:border-[#c9a24b] hover:text-[#4b3a2f]"
                }`}
              >
                {c.label}
              </button>
            )
          )}
        </div>

        {loading ? (
          <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="h-96 animate-pulse rounded-2xl bg-[#f2e9dd]" />
            ))}
          </div>
        ) : products.length === 0 ? (
          <div className="mt-20 text-center">
            <p className="font-serif-d text-3xl text-[#4b3a2f]">{t("msgs.catalog_empty_title", "Aún no hay servicios en esta categoría")}</p>
            <p className="mt-3 text-sm text-[#6b5b52]">{t("msgs.catalog_empty_text", "Prueba con otro filtro o vuelve pronto.")}</p>
          </div>
        ) : (
          <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            {products.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Catalog;
